import { cva, type VariantProps } from 'class-variance-authority'
import type * as React from 'react'
import { cn } from '../lib/utils'

const noticeVariants = cva('rounded-md border px-4 py-3 text-sm', {
  variants: {
    tone: {
      neutral: 'border-line bg-paper text-ink-soft',
      /** Red means "needs action". */
      attention: 'border-pen/25 bg-pen-soft text-pen',
      /** Green means "approved". */
      ok: 'border-ok/25 bg-ok-soft text-ok',
      /** Saffron highlights without alarm. */
      highlight: 'border-saffron/40 bg-saffron-soft text-saffron-ink',
    },
  },
  defaultVariants: { tone: 'neutral' },
})

/** An inline message. Use `role="alert"` for errors that appear after an action. */
export function Notice({
  className,
  tone,
  ...props
}: React.ComponentProps<'div'> & VariantProps<typeof noticeVariants>) {
  return <div data-slot="notice" className={cn(noticeVariants({ tone }), className)} {...props} />
}
